import { ServicesEdit } from './services-edit';

export default ServicesEdit;
